













































import Vue from 'vue'
import DocumentUploader from '@/UI/Auction/Documentations/DocumentUploader.vue'
import { FileUploadOptions } from '@/UI/Shared/FileUpload/FileUploadOptions'
import SimpleCheckBox from '@/UI/Shared/SimpleCheckBox.vue'
import DocumentationsPresented from '@/UI/Auction/Documentations/DocumentationsPresented.vue'
import { DocumentationsData } from '@/Infrastructure/Store/Auction/DocumentationsData'

interface AlreadyFiledDocumentation {
  organo: string;
  codProcedemento: string;
  ano: string;
  alreadyInCorpu: boolean;
  options: FileUploadOptions;
}

export default Vue.extend({
  name: 'DocumentationsItem',
  components: { DocumentUploader, SimpleCheckBox, DocumentationsPresented },
  props: {
    docId: {
      type: Number,
      required: true
    },
    documentationItem: {
      type: Object as () => DocumentationsData,
      required: true
    },
    procedureId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      documentationChecked: false,
      file: '',
      checkAlreadyFiled: false,
      procedureCode: '',
      procedureYear: '',
      procedureOrgano: '',
      alreadyInCorpu: false
    }
  },
  watch: {
    documentationChecked (newValue: boolean) {
      if (newValue === false) {
        this.file = ''
        this.checkAlreadyFiled = false
        this.procedureCode = ''
        this.procedureYear = ''
        this.procedureOrgano = ''
        this.alreadyInCorpu = false
        this.$emit('documentation-updated', this.serializeDocumentationData())
      }
    },
    checkAlreadyFiled (newValue: boolean) {
      if (newValue) {
        this.file = ''
      } else {
        this.procedureCode = ''
        this.procedureYear = ''
        this.procedureOrgano = ''
        this.alreadyInCorpu = false
      }
      this.$emit('documentation-updated', this.serializeDocumentationData())
    }
  },
  created () {
    this.parseDocumentationData(this.documentationItem)
  },
  methods: {
    parseDocumentationData (documentationItem: DocumentationsData): void {
      this.documentationChecked = documentationItem.checked
      this.checkAlreadyFiled = documentationItem.presentada
      this.file = documentationItem.file
      this.procedureCode = documentationItem.codProcedemento
      this.procedureYear = documentationItem.ano
      this.procedureOrgano = documentationItem.organo
      this.alreadyInCorpu = documentationItem.alreadyInCorpu
    },
    serializeDocumentationData (): DocumentationsData {
      return {
        idItem: this.docId,
        file: this.file,
        organo: this.procedureOrgano,
        codProcedemento: this.procedureCode,
        ano: this.procedureYear,
        checked: this.documentationChecked,
        presentada: this.checkAlreadyFiled,
        alreadyInCorpu: this.alreadyInCorpu
      }
    },
    onFileAddComplete (name: string) {
      this.file = name
      if (name !== '') {
        this.checkAlreadyFiled = false
        this.alreadyInCorpu = false
        this.procedureCode = ''
        this.procedureYear = ''
        this.procedureOrgano = ''
      }
      this.$emit('documentation-updated', this.serializeDocumentationData())
    },
    onAlreadyFiledDocumentationChanged ($event: AlreadyFiledDocumentation) {
      this.procedureCode = $event.codProcedemento
      this.procedureYear = $event.ano
      this.procedureOrgano = $event.organo
      this.alreadyInCorpu = $event.alreadyInCorpu
      this.$emit('documentation-updated', this.serializeDocumentationData())
    }
  }
})
